import { Page } from "components/Page";

import "react-tabulator/css/bootstrap/tabulator_bootstrap.min.css";
import "react-tabulator/lib/styles.css";

import { useEffect, useState } from "react";
import { Outlet, useRouteLoaderData } from "react-router-dom";
import { Msag } from "services/MSAGRecord";

const MSAGRecordsView = () => {
  const viewdata: Msag | any = useRouteLoaderData("view_msag_id");
  const editData: Msag | any = useRouteLoaderData("edit_msag_id");
  const [id, setId] = useState<string>("");

  useEffect(() => {
    if (viewdata !== undefined) {
      setId(viewdata.id);
    } else if (editData !== undefined) {
      setId(editData.id);
    } else {
      setId("");
    }
  }, [viewdata, editData]);

  return (
    <Page
      parentRoute="/msag-records"
      label="MSAG Records"
      title={id}
      breadCrumb={{ id: "id", title: id, active: id ? true : undefined }}
    >
      <Outlet />
    </Page>
  );
};

export default MSAGRecordsView;
